import { useMutation, useQueryClient } from '@tanstack/react-query'
import { accountApiService, accountQueries } from '@/services/accountApi'
import type { AccountSettings } from '@/types/account'

export const useUpdateAccountSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (settings: Partial<AccountSettings>) =>
      accountApiService.updateSettings(settings),
    onSuccess: (data) => {
      queryClient.setQueryData(accountQueries.settings().queryKey, data)
    },
  })
}
